import { Controller } from "stimulus"

export default class extends Controller {

    initialize() {
        this.setTaxRate();
    }
    calculateTax() {
        var isFormValid = document.getElementById("amount").checkValidity() && document.getElementById("tax_rate").checkValidity()
        if (isFormValid) {
            document.getElementById("tax-calculation").classList.remove("hidden");
            var amount = Number(document.getElementById("amount").value) || 0;
            var taxRate = Number(document.getElementById("tax_rate").value) || 0;
            var taxType = document.getElementById("taxtype").value;
            var netAmount, tax, grossAmount;
            var format = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
            });
            if (taxType === "include") {
                netAmount = amount * 100 / (taxRate + 100);
                tax = amount - Number(netAmount);
                grossAmount = amount;
            } else {
                netAmount = amount;
                tax = amount * (taxRate) / 100;
                grossAmount = amount + Number(tax);
            }
            document.getElementById("netamount").innerText = `${format.format(netAmount)}`;
            document.getElementById("tax").innerText = `${format.format(tax)}`;
            document.getElementById("rate").innerText = `${taxRate}%`;
            document.getElementById("grossamount").innerText = `${format.format(grossAmount)}`;
        }
    }

    copy() {
        var copyElement = document.getElementById("copy-content")
        copyElement.focus()
        this.selectText(copyElement)
        document.execCommand("copy");
        if (window.getSelection) {
            window.getSelection().removeAllRanges();
        } else if (document.selection) {
            document.selection.empty();
        }
    }

    selectText(node) {
        if (document.body.createTextRange) {
            const range = document.body.createTextRange();
            range.moveToElementText(node);
            range.select();
        } else if (window.getSelection) {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(node);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }


    setTaxRate() {
        var value = document.getElementById('tax-rate').value;
        document.getElementById("fixed-tax-rate").innerText = value;
    }

}